<template>
  <div class="enterprise-list-page enterprise-list-page--purchase enterprise-list-page--pharmacy-purchase">
    <!-- Header Card -->
        <PageHeader icon="fas fa-file-contract">
      <template #title>
        Daftar Purchase Order Farmasi {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola purchase order dan pemesanan obat/alkes ke supplier distributor
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                @click="$router.push('/purchase-orders-pharmacy/add')"
                v-if="manipulateBtn">
                <i class="fas fa-plus"></i>
                <span>Tambah PO</span>
              </b-button>
      </template>
    </PageHeader>

    <!-- Component List -->
    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <modern-filter-bar
              embedded
              single-line
              inline-period
              :show-timeseries="false"
              :search-text.sync="filter.po_no"
              :show-period="true"
              :start-date.sync="filter.start_date"
              :end-date.sync="filter.end_date"
              search-placeholder="Cari nomor PO"
              @search-keyup="filterByName"
              @period-search="filterByPeriode"
              @period-reset="resetFilterPeriode"
            />

            <!-- Table -->
            <medhop-data-table
              summary-title="Purchase Order Farmasi"
              striped
              hover
              class="mt-3"
              :items="items"
              :fields="fields"
              :style="'white-space: nowrap'"
              responsive
            >
              <template #table-colgroup="scope">
                <col
                  v-for="field in scope.fields"
                  :key="field.key"
                  :style="{ width: field.key === 'actions' ? '15%' : '' }"
                />
              </template>
              <template #cell(actions)="data">
                <b-button v-if="data.item.procurement_status === 'draft'" size="sm" class="mr-1 btn-primary" title="Setujui PO" @click="processPO(data.item, 'approve')"><i class="fas fa-check"></i></b-button>
                <b-button v-if="data.item.procurement_status === 'approved'" size="sm" class="mr-1 btn-primary" title="Tandai dikirim ke vendor" @click="processPO(data.item, 'send')"><i class="fas fa-paper-plane"></i></b-button>
                <b-button v-if="['approved','ordered'].includes(data.item.procurement_status)" size="sm" class="mr-1 btn-warning" title="Catat penerimaan obat/alkes" @click="processPO(data.item, 'receive')"><i class="fas fa-box-open"></i></b-button>
                <b-button v-if="data.item.procurement_status === 'received'" size="sm" class="mr-1 btn-success" title="Catat invoice vendor" @click="openVendorInvoice(data.item)"><i class="fas fa-file-invoice-dollar"></i></b-button>
                <b-button
                  size="sm"
                  class="mr-1 btn-info"
                  v-b-tooltip.hover
                  title="Detail"
                  @click="
                    $router.push({
                      path: '/purchase-orders-pharmacy/detail/' + data.item.id,
                    })
                  "
                >
                  <i class="fas fa-eye px-0"></i>
                </b-button>
                <b-button
                  size="sm"
                  class="mr-1 btn-success"
                  v-b-tooltip.hover
                  title="Edit"
                  @click="
                    $router.push({
                      path: '/purchase-orders-pharmacy/edit/' + data.item.id,
                    })
                  "
                  v-if="manipulateBtn && data.item.procurement_status === 'draft'"
                >
                  <i class="fas fa-edit px-0"></i>
                </b-button>
                <b-button
                  size="sm"
                  class="btn-danger"
                  v-b-tooltip.hover
                  title="Hapus"
                  @click="deleteData(data.item.id)"
                  v-if="manipulateBtn && data.item.procurement_status === 'draft'"
                >
                  <i class="fas fa-trash px-0"></i>
                </b-button>
              </template>
              <template #cell(total_amount)="data"><span class="po-amount">{{ money(data.item.total_amount) }}</span></template>
              <template #cell(procurement_status)="data"><span :class="['po-status','is-'+data.item.procurement_status]">{{ statusLabel(data.item.procurement_status) }}</span></template>
              <template #cell(payment_status)="data"><span :class="['po-status','is-'+data.item.payment_status]">{{ statusLabel(data.item.payment_status) }}</span></template>
            </medhop-data-table>
            <medhop-pagination
              v-if="items.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @page-click="pageOnClick"
              class="mt-4"
            ></medhop-pagination>
          </template>
        </Card>
      </div>
    </div>
    <b-modal id="pharmacy-vendor-invoice-modal" hide-footer centered title="Catat Invoice Vendor Farmasi">
      <div class="vendor-invoice-summary"><small>PO</small><b>{{ selectedPO.po_no }}</b><small>Vendor</small><b>{{ selectedPO.vendor_name }}</b><small>Nilai tagihan</small><strong>{{ money(selectedPO.total_amount) }}</strong></div>
      <div class="vendor-invoice-form"><label>Nomor invoice vendor<b-form-input v-model.trim="vendorInvoice.vendor_invoice_number" /></label><label>Tanggal invoice<b-form-input type="date" v-model="vendorInvoice.vendor_invoice_date" /></label><label>Jatuh tempo<b-form-input type="date" v-model="vendorInvoice.due_date" /></label></div>
      <div class="vendor-invoice-actions"><b-button variant="outline-secondary" @click="$bvModal.hide('pharmacy-vendor-invoice-modal')">Batal</b-button><b-button variant="primary" @click="saveVendorInvoice"><i class="fas fa-save mr-1"></i> Bentuk Utang Vendor</b-button></div>
    </b-modal>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import module from "@/core/modules/CrudModule.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { debouncer } from "@/core/modules/Helper.js";
import ApiService from "@/core/services/api.service.js";

export default {
  name: "List",

  components: {
    Card,
  },

  data() {
    return {
      // Filter
      // Filter
      filter: {
        po_no: "",
        start_date: "",
        end_date: "",
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "date",
          label: "Tanggal",
          sortable: true,
        },
        {
          key: "po_no",
          label: "No PO",
          sortable: true,
        },
        {
          key: "vendor_name",
          label: "Kepada",
          sortable: true,
        },
        { key: "total_amount", label: "Nilai PO", sortable: true },
        { key: "procurement_status", label: "Status PO", sortable: true },
        { key: "payment_status", label: "Pembayaran", sortable: true },
        {
          key: "discount",
          label: "Diskon(%)",
          sortable: true,
        },
        {
          key: "ppn",
          label: "PPn(%)",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      selectedPO: {},
      vendorInvoice: {},
      // user access
      manipulateBtn: false,
      clinic_name : window.configuration == null ? "Medhop" :  window.configuration.clinic_name
    };
  },

  methods: {
    money(value){return new Intl.NumberFormat('id-ID',{style:'currency',currency:'IDR',maximumFractionDigits:0}).format(Number(value||0));},
    statusLabel(value){return ({draft:'Draft',approved:'Disetujui',ordered:'Dikirim',received:'Diterima',invoiced:'Ditagihkan',closed:'Selesai',not_invoiced:'Belum Ditagihkan',open:'Belum Dibayar',partial:'Sebagian',paid:'Lunas'}[value]||value||'-');},
    async processPO(po,action){try{await ApiService.post(`pharmacy-purchase-orders/${po.id}/${action}`,{});await this.pagination();}catch(e){this.$bvToast.toast((e.response&&e.response.data&&e.response.data.message)||'Proses PO Farmasi gagal.',{title:'Tidak dapat diproses',variant:'danger',solid:true});}},
    openVendorInvoice(po){const today=new Date().toISOString().slice(0,10),due=new Date();due.setDate(due.getDate()+30);this.selectedPO=po;this.vendorInvoice={vendor_invoice_number:'',vendor_invoice_date:today,due_date:due.toISOString().slice(0,10)};this.$bvModal.show('pharmacy-vendor-invoice-modal');},
    async saveVendorInvoice(){try{await ApiService.post(`pharmacy-purchase-orders/${this.selectedPO.id}/vendor-invoice`,this.vendorInvoice);this.$bvModal.hide('pharmacy-vendor-invoice-modal');await this.pagination();this.$router.push({path:'/finance',query:{tab:'payables'}});}catch(e){this.$bvToast.toast((e.response&&e.response.data&&e.response.data.message)||'Invoice vendor gagal disimpan.',{title:'Tidak dapat disimpan',variant:'danger',solid:true});}},
    pageOnClick(page) {
      this.currentPage = page;
      this.pagination();
    },

    async pagination() {
      let filterParams = `&po_no=${this.filter.po_no}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`;
      let response = await module.paginate(
        "pharmacy-purchase-orders",
        `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
      );
      let pagination = response.meta.pagination;
      this.totalRows = pagination.total;

      let a, b;
      b = this.perPage * (this.currentPage - 1) + 1;
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a;
      }

      this.items = response.data;
    },

    filterByName() {
      debouncer(() => {
        this.currentPage = 1;
        this.pagination();
      }, 500);
    },

    filterByPeriode() {
      this.currentPage = 1;
      this.pagination();
    },

    resetFilterPeriode() {
      this.filter.start_date = "";
      this.filter.end_date = "";
      this.pagination();
    },

    async deleteData(id) {
      // Delete Data
      let result = await module.delete("pharmacy-purchase-orders/" + id);
      // If Deleted
      if (result) {
        this.pagination();
      }
    },

    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);

      let a;
      for (a = 0; a < access_right.length; a++) {
        ;

        if (access_right[a] == "1407") {
          this.manipulateBtn = true;
        }
      }
    },
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Purchase Order Farmasi" },
    ]);
    // Get Data
    this.pagination();
    this.setActiveMenu();
  },
};
</script>

<style scoped>
.po-amount{font-weight:750;color:#164f7f}.po-status{display:inline-flex;align-items:center;padding:5px 9px;border-radius:999px;background:#eef3f7;color:#53677d;font-size:11px;font-weight:750}.po-status.is-approved,.po-status.is-received{background:#e5f6f0;color:#13815e}.po-status.is-ordered,.po-status.is-partial{background:#fff2df;color:#a86700}.po-status.is-invoiced,.po-status.is-open{background:#e9f2fc;color:#17649a}.po-status.is-closed,.po-status.is-paid{background:#e4f7ec;color:#148150}.vendor-invoice-summary{display:grid;grid-template-columns:120px 1fr;gap:7px;padding:14px;border-radius:12px;background:#f4f8fb;margin-bottom:14px}.vendor-invoice-summary small{color:#738499}.vendor-invoice-summary strong{color:#14877d}.vendor-invoice-form{display:grid;grid-template-columns:1fr 1fr;gap:12px}.vendor-invoice-form label:first-child{grid-column:1/-1}.vendor-invoice-form label{font-size:12px;font-weight:700;color:#40546a}.vendor-invoice-actions{display:flex;justify-content:flex-end;gap:8px;margin-top:18px;padding-top:13px;border-top:1px solid #e3ebf1}@media(max-width:767px){.vendor-invoice-form{grid-template-columns:1fr}.vendor-invoice-form label:first-child{grid-column:auto}}
</style>
